module.exports = __webpack_public_path__ + "static/media/ic_previous_arrow.2aaf6644.svg";